<script lang="ts">
  import DownloadCard from "./ProductLineBox/DownloadCard.svelte";

  import type { Product } from "@shared/types/ProductLine";
  import type { SfProduct, VendorProduct } from "@shared/types/SevenFifty";

  export let productLineId: number;
  export let distributorId: number;
  export let selectedVintageProduct: Product;
  export let sevenFiftyProduct: SfProduct;
  export let vendorProduct: VendorProduct;

  const getVintageString = (product: Product, sfProduct: SfProduct) => {
    if (!product && sfProduct?.vintage_year) {
      return ` (${sfProduct.vintage_year})`;
    } else if (!product) {
      return "";
    }

    const vintage = product.vintage_year;
    if (!vintage) {
      return " (Current)";
    } else {
      return ` (${vintage})`;
    }
  };

  const buildSection = (sevenFiftyProduct: SfProduct, vendorProduct: VendorProduct) => {
    const cards = [];
    const vintageString = getVintageString(selectedVintageProduct, sevenFiftyProduct);
    if (sevenFiftyProduct?.shelf_talker) {
      cards.push({
        title: `Shelf Talker${vintageString}`,
        targetObjectType: "supplier_shelf_talker",
        source: "Supplier",
        url: sevenFiftyProduct.shelf_talker,
        key: `supplier-shelf-talker-${sevenFiftyProduct.product_id}`,
      });
    }
    if (vendorProduct?.shelf_talker) {
      cards.push({
        title: `Shelf Talker${vintageString}`,
        targetObjectType: "distributor_shelf_talker",
        source: "Distributor",
        url: vendorProduct.shelf_talker,
        key: `distributor-shelf-talker-${vendorProduct.vendor_product_id}`,
      });
    }
    if (sevenFiftyProduct?.supplier_tech_sheet) {
      cards.push({
        title: `Tech Sheet${vintageString}`,
        targetObjectType: "supplier_tech_sheet",
        source: "Supplier",
        url: sevenFiftyProduct.supplier_tech_sheet,
        key: `supplier-tech-sheet-${sevenFiftyProduct.product_id}`,
      });
    }
    if (vendorProduct?.distributor_tech_sheet) {
      cards.push({
        title: `Tech Sheet${vintageString}`,
        targetObjectType: "distributor_tech_sheet",
        source: "Distributor",
        url: vendorProduct.distributor_tech_sheet,
        key: `distributor-tech-sheet-${vendorProduct.vendor_product_id}`,
      });
    }
    return cards;
  };

  $: downloadCards = buildSection(sevenFiftyProduct, vendorProduct);
</script>

<div class="fizz-grid" style="--grid-col-min: 300px; --grid-col-max: 310px; --gap: 0.5rem;">
  {#each downloadCards as card (card.key)}
    <span data-testid={card.key}>
      <DownloadCard
        title={card.title}
        targetObjectType={card.targetObjectType}
        source={card.source}
        url={card.url}
        {productLineId}
        {distributorId}
      />
    </span>
  {/each}
</div>
